import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    if (!getToken()) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const finishAuth = (token, u) => {
    setToken(token);
    setUser(u);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    window.location.href = "/login";
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const isManager = user && ["admin", "director", "manager"].includes(user.role);
  const isTI = false; // Perfil TI removido (Set/2026); mantido como flag falsa para compat.
  const seesAll = user && ["admin", "diretor_geral"].includes(user.role);
  const isLogisticaAdm = user && user.role === "logistica_adm";
  const isTVCorp = user && user.role === "tv_corporativa";

  return (
    <AuthContext.Provider
      value={{ user, loading, login, logout, finishAuth, refreshUser, setUser, isManager, isTI, seesAll, isLogisticaAdm, isTVCorp }}
    >
      {children}
    </AuthContext.Provider>
  );
}
